import RedirectPaymentForm from "../shared/RedirectPaymentForm";

/**
 * Hosted-page Open Banking (Trustly) tile.
 *
 * Pure redirect flow with no method-specific data to collect and no customer-
 * facing brand (Trustly is the processor, not the user-visible payment
 * method). Just renders the shared "you'll be redirected" notice.
 */
const TrustlyOpenBankingForm = (props) => (
  <RedirectPaymentForm
    {...props}
    paymentMethod="openbanking"
    gateway="trustly"
    requireEmail
  />
);

export default TrustlyOpenBankingForm;
